import React, { useRef } from "react";
import PropTypes from "prop-types";

import { Base } from "../base";

import styles from "./empty.css";

export function Empty(props) {
  const baseRef = useRef(null);

  return (
    <Base {...props} ref={baseRef}>
      <div className={styles.empty}>&nbsp;</div>
    </Base>
  );
}

Text.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any
};
